import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import template from './index.jade';
import css from './index.inline.styl';

export class DatasetCard extends Component<EmptyObj> {
  static get attrsSchema(): any {
    return {
      ...super.attrsSchema,
      'img-name': {type: `string`, description: `name used for css bg-img mixin`},
      'project-id': {type: `number`, description: `mixpanel project id for this demo`},
      selected: {type: `boolean`, description: `whether or not this is the currently selected demo`},
      text: {type: `string`, description: `larger and bolder text under image`},
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}

export const DatasetCardEl = defineAndMakeJsxFactory(`mp-dataset-card`, DatasetCard);
export const DatasetCardReact = panel2react(`mp-dataset-card`, DatasetCard);
